import React from "react";
import {Stack, Typography, Skeleton} from "@mui/material";
import {ColletteDivider} from "@collette-travel/collette-common-controls";
import {ColletteTourOverviewHeaderSkeletonProps} from "../types";
import InfoIcon from "../info-icon";

const KeyTourInfoSkeletonRow = ({
  testId,
  details,
  labelColor = "primary",
  showDividers = true,
  infoIconVariant = "outlined",
  sxOverride = {}
}: ColletteTourOverviewHeaderSkeletonProps) => (
  <Stack
    sx={{
      flexDirection: "row",
      display: "flex",
      gap: "2.4rem",
      width: "auto",
      justifyContent: "normal",
      ...sxOverride
    }}
    data-testid={`${testId}_tour-overview-header-skeleton`}
  >
    {details.map((detail, index) => (
      <Stack
        direction="row"
        gap="2.4rem"
        key={detail.id}
      >
        <Stack
          sx={{
            gap: "0.8rem",
            flexDirection: "column",
            justifyContent: "flex-start",
            alignItems: "start"
          }}
          data-testid={`${testId}_tour-overview-header-skeleton_${detail.id}_cell`}
        >
          <Stack
            sx={{
              flexDirection: "row",
              alignItems: "center",
              gap: "0.4rem"
            }}
            data-testid={`${testId}_tour-overview-header-skeleton_${detail.id}_label-container`}
          >
          <Typography
            color={labelColor}
            sx={{
              textTransform: "uppercase",
              fontSize: "1.4rem",
              fontWeight: 700,
              lineHeight: "150%",
              textWrap: "nowrap"
            }}
            data-testid={`${testId}_tour-overview-header-skeleton_${detail.id}_label`}
          >
            {detail.label ?? <Skeleton width="10rem" />}
          </Typography>
            {detail.showInfoIcon && detail.label && (
              <InfoIcon
                variant={infoIconVariant}
                color={labelColor === "primary" || labelColor === "secondary" ? labelColor : undefined}
                sx={{
                  height: "2rem",
                  width: "2rem",
                  color: labelColor === "text.disabled" ? "text.disabled" : undefined,
                  mb: "0.2rem"
                }}
              />
            )}
          </Stack>
          <Skeleton width="75%" data-testid={`${testId}_tour-overview-header-skeleton_${detail.id}_value`} />
        </Stack>
        {showDividers && index !== details.length - 1 && (
          <ColletteDivider
            orientation="vertical"
            sx={{ borderColor: "divider" }}
          />
        )}
      </Stack>
    ))}
  </Stack>
);

export default KeyTourInfoSkeletonRow;